<template>
  <base-modal
    :id="id"
    :key="id"
    v-bind="$attrs"
    :show="show"
    :modal-alert="true"
    class="confirm-toast"
    :class="{'modal-ipad': isIPad }"
    :show-close-button="showCloseButton"
    @closed="closed"
  >
    <base-heading class="heading">
      {{ title }}
    </base-heading>
    <div style="padding: 0px 24px 0px 24px;">
      <hr
        class="mb-4"
        style="border-color: #d4d4d4; margin-top: unset !important;"
      >
    </div>
    <base-text
      light
      class="message"
    >
      <!-- eslint-disable-next-line -->
        <span v-html="message" />
      <slot />
    </base-text>
    <template slot="footer" style="margin:unset;">
      <div
        v-if="showOptions"
        style="margin:unset;"
        :class="{'flex-row-reverse' : reverse}"
      >
        <slot name="actions">
          <base-button
            v-for="action in actions"
            v-show="(!action.positive && showCancel) || action.positive"
            :key="`action_${action.event}`"
            class="actions"
            :inverse="action.positive"
            :class="`${!action.positive ? 'mx-4' : ''}`"
            @click.native="$emit(action.event)"
          >
            {{ action.text }}
          </base-button>
        </slot>
      </div>
    </template>
  </base-modal>
</template>
<script>
import whichbrowser from '@/components/mixins/whichbrowser';

export default {
  name: 'BaseConfirmDialogExtended',
  mixins: [whichbrowser],
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showOptions: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    positiveText: {
      type: String,
      default: 'Accept',
    },
    negativeText: {
      type: String,
      default: 'Cancel',
    },
    message: {
      type: String,
      default: 'Are you sure?',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      id: `confirm-dialog-${Date.now()}`,
      showModal: true,
    };
  },
  computed: {
    actions() {
      return [
        { positive: false, text: this.negativeText, event: 'cancelled' },
        { positive: true, text: this.positiveText, event: 'confirmed' },
      ];
    },
  },
  watch: {
    showModal(newval) {
      if (newval) {
        this.refreshId();
      }
    },
  },
  mounted() {
    this.refreshId();
  },
  methods: {
    closed() {
      this.$emit('cancelled');
      this.$emit('closed');
    },
    refreshId() {
      this.id = `confirm-dialog-${Date.now()}`;
    },
  },
};
</script>
<style lang="scss"
  scoped>
.confirm-toast {
  ::v-deep .modal-dialog {
    justify-content: center;
    max-width: 570px !important;
    top: 36%;
    transform: translateY(calc(-50% + 40px));
    margin-top: 0;

    .modal-content {
      width: 500px !important;
      border: none !important;
      border-radius: 4px !important;
      // padding-left: 34px; //default
      // padding-right: 34px; //default
      .modal-body {
        padding: 0px !important;

        .base-button {
          font-family: 'SilkaLight';
          padding: 10px 12px;
          border: 1px solid #D6D6D6;
          margin-right: unset !important;
          // border: none;

          &--inverse {
            border: none;
            padding: 10px 12px;
            margin-left: 12px !important;
          }
        }
      }
    }
    .close {
      // margin-top: 19px;
      // margin-right: 9px;
      img {
        margin-bottom: 5px;
        width: 13px;
        height:  13px;
      }
    }
  }
}
.modal-ipad ::v-deep .modal-dialog{
  top: 28%;
}
.message {
  color: black;
  font-size: 16px;
  padding: 24px;
}
.heading{
  margin-left: -8px !important;
  font-weight: 600 !important;
  font-size: 19px !important;
  background: transparent;
  font-family: 'Tiempos';
  font-style: normal;
  line-height: 120%;
  padding-left: 34px;
  padding-right: 34px;
}
::v-deep .base-heading {
  margin-bottom: 0.45rem !important;
}

::v-deep .actions {
  font-family: $font-family-sans-serif;
  padding: 8.5px 16px !important;
  font-size: 14px;
  height: 36px;
}
</style>
